import React, { useState } from 'react';
import { CRYPTO_ICONS, TRADING_COLORS as C } from './constants';

const CoinIcon = ({ symbol, size = 24 }) => {
  const base = symbol?.replace(/USDT|USD|PERP/g, '') || 'BTC';
  const [iconIndex, setIconIndex] = useState(0);
  
  // Multiple icon sources to try
  const iconSources = [
    CRYPTO_ICONS[base], // Our predefined icons
    `https://assets.coincap.io/assets/icons/${base.toLowerCase()}@2x.png`, // CoinCap
    `https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@master/32/color/${base.toLowerCase()}.png`, // Atomic Labs
    `https://raw.githubusercontent.com/spothq/cryptocurrency-icons/master/32/color/${base.toLowerCase()}.png`, // SpotHQ
  ].filter(Boolean);
  
  const currentSrc = iconSources[iconIndex];
  
  if (currentSrc && iconIndex < iconSources.length) {
    return (
      <img 
        src={currentSrc} 
        alt={base} 
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover' }} 
        onError={() => setIconIndex(prev => prev + 1)}
        loading="lazy"
      />
    );
  }
  
  // Fallback to letters
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%',
      background: `linear-gradient(135deg, ${C.yellow}, #d4a00a)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: size * 0.38, fontWeight: 700, color: '#000',
    }}>{base.slice(0, 2)}</div>
  );
};

export default CoinIcon;
